/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { getFirestore, collection, query, where, Firestore, onSnapshot } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirestoreService {
  private firestore: Firestore;

  constructor() {
    const app = initializeApp(environment.firebaseConfig);
    this.firestore = getFirestore(app);
  }

  getActiveDeployment(): Observable<any> {
    const colRef = collection(this.firestore, 'deployments');
    const q = query(colRef, where('active', '==', true));
    return new Observable((observer) => {
      onSnapshot(
        q,
        (snapshot) => {
          if (!snapshot.empty) {
            observer.next(snapshot.docs[0].data());
          } else {
            observer.next(null);
          }
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getAppVersion(): Observable<any> {
    const colRef = collection(this.firestore, 'appVersions');
    const q = query(colRef, where('current', '==', true));

    return new Observable((observer) => {
      onSnapshot(
        q,
        (snapshot) => {
          if (!snapshot.empty) {
            observer.next(snapshot.docs[0].data());
          } else {
            observer.next(null);
          }
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
}
